<template>
  <div class="about-detail" ref="aboutDetail">
    <div class="left">
      <div class="p1"  :class="globalTransition">
        <p>{{$t('projectPage.p2.p1')}}</p>
        <p>{{$t('projectPage.p2.p2')}}</p>
        <p>{{$t('projectPage.p2.p3')}}</p>
      </div>
      <div class="p2 color-block"  :class="projectTransition">
        <img :src="currentImgUrl" alt="DIMER" class="aboutImg1">
        <el-button type="primary" class="next-btn" icon="el-icon-arrow-right"
        @click="nextProject"></el-button>
      </div>
      <div class="p3"  :class="globalTransition">
        <p :class="projectTransition">{{$t('projectPage.projectList.'+currentProject+'.name')}}</p>
      </div>
      <div class="p3-time"  :class="globalTransition">
        <p :class="projectTransition">{{$t('projectPage.projectList.'+currentProject+'.time')}}</p>
      </div>
      <div class="p4"  :class="globalTransition">
        <p :class="projectTransition">
          {{$t('projectPage.projectList.'+currentProject+'.content')}}</p>
      </div>
    </div>
    <div class="right color-block1" :class="rightPosition?'LockPosition':''">
      <div class="title"  :class="globalTransition">
        <h2>{{$t('about.latestProj')}}</h2>
      </div>
      <div class="content"  :class="globalTransition">
        <div v-for="(event,index) in projectList" :key="index" class="news-item"
             :class="event === currentProject?'hoverd':''" @click="changeCurrentProj(event)">
          <p class="p1">0{{index+1}}.</p>
          <p class="p2">{{$t('aboutPage.p2.news.state')}}</p>
          <p class="p3">{{$t('projectPage.projectList.'+event+'.name')}}</p>
           <!-- <p class="p4" v-if="language==='zh'">{{(new Date(event.date)).toLocaleDateString()}}
           </p>-->
          <p class="p4">{{$t('projectPage.projectList.'+event+'.time')}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import project1 from '@/assets/project1.jpg';
import project2 from '@/assets/project2.jpg';
import project3 from '@/assets/project3.jpg';
import project4 from '@/assets/project4.jpg';
import project5 from '@/assets/project5.jpg';

export default {
  name: 'productDetail',
  props: {
    tops: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      project1Url: project1,
      project2Url: project2,
      project3Url: project3,
      project4Url: project4,
      project5Url: project5,
      doTransition: false,
      rightPosition: false,
      newwList: [
        { id: '01', title: 'news1', date: '2019-06-03' },
        { id: '02', title: 'news2', date: '2019-05-28' },
        { id: '03', title: 'news3', date: '2019-03-12' },
        { id: '04', title: 'news4', date: '2019-02-05' },
      ],
      currentProject: 'project1',
      projectList: ['project1', 'project2', 'project3', 'project4', 'project5'],
      anthor: '',
    };
  },
  mounted() {
    this.author = this.$route.query.anchor;
    if (this.author && !isNaN(this.author.slice(0, 1))) {
      this.currentProject = `project${this.author.slice(0, 1)}`;
    }
    // window.addEventListener('scroll', this.handleScroll, true);
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
    globalTransition() {
      return this.$store.getters.globalTransition ? 'global-i18n-hide' : 'global-i18n-not-hide';
    },
    projectTransition() {
      return this.doTransition ? 'project-hide' : 'project-not-hide';
    },
    currentImgUrl() {
      return this[`${this.currentProject}Url`];
    },
    anchors() {
      return this.$route.query.anchor;
    },
  },
  watch: {
    anchors() {
      if (this.anchors && !isNaN(this.anchors.slice(0, 1))) {
        this.currentProject = `project${this.anchors.slice(0, 1)}`;
      }
    },
  },
  methods: {
    changeCurrentProj(event) {
      if (event !== this.currentProject) {
        this.doTransition = !this.doTransition;
        setTimeout(() => {
          this.doTransition = !this.doTransition;
          this.currentProject = event;
        }, 150);
      }
    },
    nextProject() {
      const pos = this.projectList.indexOf(this.currentProject);
      this.changeCurrentProj(this.projectList[this.projectList.length === pos + 1 ? 0 : pos + 1]);
    },
    handleScroll() {
      /*      if (this.$refs.aboutDetail !== undefined) {
        if (this.tops >= this.$refs.aboutDetail.offsetTop) {
          this.rightPosition = true;
        } else {
          this.rightPosition = false;
        }
      } */
    },
  },
};
</script>

<style lang="scss" scoped>
  .about-detail {
    padding-top: 50px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    .left {
      width: 65%;
      display: flex;
      flex-direction: column;
      .p1 {
        color: #369ff6;
      }
      .p1 {
        h1 {
          font-weight: 900!important;
          letter-spacing: 5px;
        }
        padding: 0px 15%;
        line-height: 2rem;
        letter-spacing: 1px;
        font-size: 1.1rem;
      }
      .p2{
        width: 100%;
        display: flex;
        flex-direction: column;
        .aboutImg1 {
          padding-top: 50px;
          width: 80%;
        }
        .next-btn{
          position: relative;
          width: 80px;
          height: 80px;
          bottom: 80px;
          left: calc(80% - 80px);
          border-radius: 0px;
          font-size: 40px;
        }
      }
      .p3 {
        padding: 50px 15% 0px 15%;
        line-height: 12px;
        letter-spacing: 1px;
        font-weight: bold;
        font-size: 2rem;
        p{
          font-size: 1.4rem;
          margin-block-end: 0;
        }
      }
      .p3-time {
        padding: 6px 15% 10px 15%;
        line-height: 0px;
        color: #369ff6;
      }
      .p4 {
        padding: 10px 15% 80px 15%;
        line-height: 2rem;
      }
    }
    .doTransition{
      opacity: 0;
      transition:ease 0.25s;
    }
    .unDoTransition{
      opacity: 100;
      transition:ease 0.25s;
    }
    .right {
      width: 35%;
      .title{
        padding-left: 20px;
      }
    }
  }

  .news-item {
    padding: 20px;
    cursor: pointer;
    font-size: 1.4rem;
    .p1 {
      color: #369ff6;
      font-weight: bold;
    }
    .p3 {
      font-weight: bold;
      line-height: 0px;
    }
    .p4 {
      color: #666;
      line-height: 12px;
      font-size: 1rem;
    }
  }

  .news-item:hover{
    background-color: #409EFF;
    transition: 0.3s;
    color: #fff;
    .p1{
      color: #fff;
    }
    .p4{
      color: #fff;
    }
  }
  .hoverd{
    background-color: #409EFF;
    transition: 0.3s;
    color: #fff;
    .p1{
      color: #fff;
    }
    .p4{
      color: #fff;
    }
  }
  .color-block{
    background-size: 160px;
    background-position-x: calc(80% + 48px);
    background-position-y:100%;
    background-repeat: no-repeat;
    background-image:url("../../assets/color-block.png");
  }
  .color-block1{
    background-size: 100px;
    background-position-x: 100%;
    background-position-y: 90%;
    background-repeat: no-repeat;
    background-image:url("../../assets/color-block.png");
  }
  .project-hide{
    opacity: 0;
    transition: ease 0.15s;
  }
  .project-not-hide{
    opacity: 100;
    transition: ease 0.15s;
  }
  .LockPosition{
    position: fixed;
    right: 18px;
    top: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/views/projectPage/detail.vue